export default __webpack_public_path__ + "static/media/icon_tips_more.37626cc7.svg";